import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { requestDeleteSpaceById } from "services/settings/spaceAdmin/aboutSpaceAdmin";
import { FORM_ACTION_ERRORS } from "../../components/RegisterSpaceForm/utils/constants";
import useMainContext from "utils/context/useMainContext";

const useDeleteSpace = ({
	loadingRequest, form, onSuccess
}) => {
    const mainContext = useMainContext();
    const dialogConfirmDelete = useShowDialogAlert();
    const dialogErrorForFutureReservationsInDeletion = useShowDialogAlert();
	async function deleteSpace() {
        dialogConfirmDelete.hide();
        loadingRequest.show("Eliminando espacio...");
        const { id } = form.value;
        const { success, message } = await requestDeleteSpaceById(id);
        loadingRequest.hide();
        if (success) {
            onSuccess(id);
            return;
        }
        onError(message);
    }
    function onError(message) {
        switch (message) {
            case FORM_ACTION_ERRORS.FUTURE_RESERVATIONS:
                dialogErrorForFutureReservationsInDeletion.set(true);
                return;
            default:
                mainContext.setShowDialogUnexpectedError();
        }
    }
	return {
		deleteSpace,
		dialogs: {
			dialogConfirmDelete,
			dialogErrorForFutureReservationsInDeletion
		}
	};
}	
	
export default useDeleteSpace;